import { Inject } from 'inversify-props'
import { ClienteServiceAdapter } from './adapter'
import { Cliente, Page } from '@/models'
import { AxiosRequestConfig } from 'axios'

export class FindClienteUseCase {
	@Inject('ClienteServiceAdapter')
	private clienteServiceAdapter!: ClienteServiceAdapter

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cliente>> =>
		await this.clienteServiceAdapter.find(params, config)

	findClienteComCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cliente>> =>
		await this.clienteServiceAdapter.findClienteComCashback(params, config)


	get = async (id: string): Promise<Cliente> =>
		await this.clienteServiceAdapter.get(id)

	validarClubeDoCliente = async (cpfOuCnpjCliente: string): Promise<Cliente> =>
		await this.clienteServiceAdapter.validarClubeDoCliente(cpfOuCnpjCliente)
}
